
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPo05DtPendingPIforIrGrid extends Serenity.EntityGrid<PoPo05DtPendingPIforIrRow, any> {
        protected getColumnsKey() { return PoPo05DtPendingPIforIrColumns.columnsKey; }
        protected getDialogType() { return PoPo05DtPendingPIforIrDialog; }
        protected getIdProperty() { return PoPo05DtPendingPIforIrRow.idProperty; }
        protected getInsertPermission() { return PoPo05DtPendingPIforIrRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPo05DtPendingPIforIrRow.localTextPrefix; }
        protected getService() { return PoPo05DtPendingPIforIrService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}